var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingBagSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F9EBB2",
    d: "M22,12c0-5.523,4.478-10,10-10s10,4.477,10,10v12h-2V12c0-4.418-3.582-8-8-8s-8,3.582-8,8v12h-2V12z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#45AAB8",
    d: "M10,60c0,1.104,0.896,2,2,2h40c1.104,0,2-0.896,2-2v-2H10V60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#45AAB8",
    d: "M53,22h-9v3c0,0.553-0.447,1-1,1h-4c-0.553,0-1-0.447-1-1v-3H26v3c0,0.553-0.447,1-1,1h-4 c-0.553,0-1-0.447-1-1v-3h-9c-0.553,0-1,0.447-1,1v33h44V23C54,22.447,53.553,22,53,22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M54,20H44v-8c0-6.627-5.373-12-12-12S20,5.373,20,12v8H10c-1.105,0-2,0.895-2,2v38c0,2.211,1.789,4,4,4h40 c2.211,0,4-1.789,4-4V22C56,20.895,55.105,20,54,20z M22,12c0-5.523,4.478-10,10-10s10,4.477,10,10v12h-2V12c0-4.418-3.582-8-8-8 s-8,3.582-8,8v12h-2V12z M38,12v8H26v-8c0-3.314,2.687-6,6-6S38,8.686,38,12z M54,60c0,1.104-0.896,2-2,2H12c-1.104,0-2-0.896-2-2 v-2h44V60z M54,56H10V23c0-0.553,0.447-1,1-1h9v3c0,0.553,0.447,1,1,1h4c0.553,0,1-0.447,1-1v-3h12v3c0,0.553,0.447,1,1,1h4 c0.553,0,1-0.447,1-1v-3h9c0.553,0,1,0.447,1,1V56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M36,34c-1.104,0-2.104,0.447-2.828,1.172L32,36.336l-1.172-1.164C30.104,34.447,29.104,34,28,34 c-2.209,0-4,1.791-4,4c0,1.104,0.713,2.135,1.438,2.859l5.855,5.855c0.391,0.391,1.023,0.391,1.414,0l5.84-5.84 C39.271,40.15,40,39.104,40,38C40,35.791,38.209,34,36,34z M37.156,39.438L32,44.594l-5.156-5.156C26.481,39.076,26,38.553,26,38 c0-1.105,0.896-2,2-2c0.553,0,1.053,0.223,1.414,0.586l1.879,1.871c0.391,0.391,1.023,0.391,1.414,0l1.879-1.871 C34.947,36.223,35.447,36,36,36c1.104,0,2,0.895,2,2C38,38.553,37.519,39.076,37.156,39.438z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F76D57",
    d: "M37.156,39.438L32,44.594l-5.156-5.156C26.481,39.076,26,38.553,26,38c0-1.105,0.896-2,2-2 c0.553,0,1.053,0.223,1.414,0.586l1.879,1.871c0.391,0.391,1.023,0.391,1.414,0l1.879-1.871C34.947,36.223,35.447,36,36,36 c1.104,0,2,0.895,2,2C38,38.553,37.519,39.076,37.156,39.438z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54,60c0,1.104-0.896,2-2,2H12c-1.104,0-2-0.896-2-2v-2h44V60z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagSvgrepoCom);
export default __webpack_public_path__ + "static/media/shopping-bag-svgrepo-com.07735909804fe24767e82a5864eddfa4.svg";
export { ForwardRef as ReactComponent };